export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9473.d4b5cffb.jpg";